import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";
import AuthenticatedMinimalLayout from "@/layouts/AuthenticatedMinimalLayout.vue";
import PublicLayout from "@/layouts/PublicLayout.vue";
import AppLayout from "@/layouts/AppLayout.vue";

export default {
    PublicLayout,
    AuthenticatedLayout,
    AuthenticatedMinimalLayout,
    AppLayout,
};
